/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Card_Book_FirstInputs */

const en_booking_card_book_first = /** @type {(inputs: Booking_Card_Book_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book first session online`)
};

const es_booking_card_book_first = /** @type {(inputs: Booking_Card_Book_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reservar primera sesión en línea`)
};

const de_booking_card_book_first = /** @type {(inputs: Booking_Card_Book_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erste Golfstunde online buchen`)
};

const zh_booking_card_book_first = /** @type {(inputs: Booking_Card_Book_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在线预订第一堂课`)
};

const ar_booking_card_book_first = /** @type {(inputs: Booking_Card_Book_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`احجز الجلسة الأولى عبر الإنترنت`)
};

const fr_booking_card_book_first = /** @type {(inputs: Booking_Card_Book_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réservez la première séance en ligne`)
};

const vi_booking_card_book_first = /** @type {(inputs: Booking_Card_Book_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đặt buổi đầu trực tuyến`)
};

const sw_booking_card_book_first = /** @type {(inputs: Booking_Card_Book_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weka nafasi ya kipindi cha kwanza mtandaoni`)
};

const th_booking_card_book_first = /** @type {(inputs: Booking_Card_Book_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จองเซสชันแรกทางออนไลน์`)
};

const bs_booking_card_book_first = /** @type {(inputs: Booking_Card_Book_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezervišite prvu sesiju online`)
};

const ja_booking_card_book_first = /** @type {(inputs: Booking_Card_Book_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最初のセッションをオンラインで予約する`)
};

const ko_booking_card_book_first = /** @type {(inputs: Booking_Card_Book_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`첫 세션 온라인 예약`)
};

const pt_booking_card_book_first = /** @type {(inputs: Booking_Card_Book_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reserve a primeira sessão online`)
};

const it_booking_card_book_first = /** @type {(inputs: Booking_Card_Book_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prenota prima sessione online`)
};

const sv_booking_card_book_first = /** @type {(inputs: Booking_Card_Book_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boka första session online`)
};

const nl_booking_card_book_first = /** @type {(inputs: Booking_Card_Book_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boek de eerste sessie online`)
};

const da_booking_card_book_first = /** @type {(inputs: Booking_Card_Book_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book første session online`)
};

const nb_booking_card_book_first = /** @type {(inputs: Booking_Card_Book_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestill første økt online`)
};

const fi_booking_card_book_first = /** @type {(inputs: Booking_Card_Book_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varaa ensimmäinen tunti verkossa`)
};

const pl_booking_card_book_first = /** @type {(inputs: Booking_Card_Book_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarezerwuj pierwszą sesję online`)
};

const ru_booking_card_book_first = /** @type {(inputs: Booking_Card_Book_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Записаться на первое занятие онлайн`)
};

const tr_booking_card_book_first = /** @type {(inputs: Booking_Card_Book_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İlk dersinizi online ayırtın`)
};

const hi_booking_card_book_first = /** @type {(inputs: Booking_Card_Book_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पहला सत्र ऑनलाइन बुक करें`)
};

const id_booking_card_book_first = /** @type {(inputs: Booking_Card_Book_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesan sesi pertama secara online`)
};

const ms_booking_card_book_first = /** @type {(inputs: Booking_Card_Book_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempah sesi pertama dalam talian`)
};

const cs_booking_card_book_first = /** @type {(inputs: Booking_Card_Book_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezervovat první lekci online`)
};

const el_booking_card_book_first = /** @type {(inputs: Booking_Card_Book_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Κάντε κράτηση για την πρώτη συνεδρία online`)
};

const he_booking_card_book_first = /** @type {(inputs: Booking_Card_Book_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הזמינו מפגש ראשון אונליין`)
};

const af_booking_card_book_first = /** @type {(inputs: Booking_Card_Book_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bespreek eerste sessie aanlyn`)
};

const hu_booking_card_book_first = /** @type {(inputs: Booking_Card_Book_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Első óra foglalása online`)
};

/**
* | output |
* | --- |
* | "Book first session online" |
*
* @param {Booking_Card_Book_FirstInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const booking_card_book_first = /** @type {((inputs?: Booking_Card_Book_FirstInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Card_Book_FirstInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_booking_card_book_first(inputs)
	if (locale === "de") return de_booking_card_book_first(inputs)
	if (locale === "zh") return zh_booking_card_book_first(inputs)
	if (locale === "ar") return ar_booking_card_book_first(inputs)
	if (locale === "fr") return fr_booking_card_book_first(inputs)
	if (locale === "vi") return vi_booking_card_book_first(inputs)
	if (locale === "sw") return sw_booking_card_book_first(inputs)
	if (locale === "th") return th_booking_card_book_first(inputs)
	if (locale === "bs") return bs_booking_card_book_first(inputs)
	if (locale === "ja") return ja_booking_card_book_first(inputs)
	if (locale === "ko") return ko_booking_card_book_first(inputs)
	if (locale === "pt") return pt_booking_card_book_first(inputs)
	if (locale === "it") return it_booking_card_book_first(inputs)
	if (locale === "sv") return sv_booking_card_book_first(inputs)
	if (locale === "nl") return nl_booking_card_book_first(inputs)
	if (locale === "da") return da_booking_card_book_first(inputs)
	if (locale === "nb") return nb_booking_card_book_first(inputs)
	if (locale === "fi") return fi_booking_card_book_first(inputs)
	if (locale === "pl") return pl_booking_card_book_first(inputs)
	if (locale === "ru") return ru_booking_card_book_first(inputs)
	if (locale === "tr") return tr_booking_card_book_first(inputs)
	if (locale === "hi") return hi_booking_card_book_first(inputs)
	if (locale === "id") return id_booking_card_book_first(inputs)
	if (locale === "ms") return ms_booking_card_book_first(inputs)
	if (locale === "cs") return cs_booking_card_book_first(inputs)
	if (locale === "el") return el_booking_card_book_first(inputs)
	if (locale === "he") return he_booking_card_book_first(inputs)
	if (locale === "af") return af_booking_card_book_first(inputs)
	if (locale === "hu") return hu_booking_card_book_first(inputs)
	return en_booking_card_book_first(inputs)
});